// extracted by mini-css-extract-plugin
export default {"container":"SwitchWidget_container__iLPGT","disabled":"SwitchWidget_disabled__mWMd7","switch":"SwitchWidget_switch__K0Y9-","slider":"SwitchWidget_slider__FPgcD"};